import Icon from "@ant-design/icons";
import { type FunctionComponent } from "react";

import { type IBTIconProps } from "../BTIcon.types";
import { useBaseIcon } from "../BTIcon.utilities";
import SVG from "../images/PaymentProcessing.svg?react";

export const BTIconPaymentProcessing: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useBaseIcon(baseProps);

    // eslint-disable-next-line react/forbid-elements
    return <Icon {...props} component={SVG} />;
};
